import Swal from 'sweetalert2';
import { auth, signOut } from '../../config/firebase';
import './style.css'
import { NavLink } from 'react-router-dom';
import { memo, useState, useEffect, createElement } from 'react';
import { BiHomeSmile } from 'react-icons/bi';
import { FcBusinessman } from 'react-icons/fc';
import { MdPayment } from 'react-icons/md';
import {
  Card,
  Typography,
  List,
  ListItem,
  ListItemPrefix,
  ListItemSuffix,
  Chip,
  Navbar,
  MobileNav,
  Button,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Avatar,
  IconButton,
} from "@material-tailwind/react";
import {
  PresentationChartBarIcon,
  CubeTransparentIcon,
  UserCircleIcon,
  CodeBracketSquareIcon,
  Square3Stack3DIcon,
  ChevronDownIcon,
  Cog6ToothIcon,
  InboxArrowDownIcon,
  LifebuoyIcon,
  PowerIcon,
  RocketLaunchIcon,
  Bars2Icon,
} from "@heroicons/react/24/solid";





function Nav() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);

  const toggleIsNavOpen = () => setIsNavOpen((cur) => !cur);

  useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setIsNavOpen(false),
    );
  }, []);




  const profileMenuItems = [

    {
      label: "Sign Out",
      icon: PowerIcon,
    },
  ];
  

  const navdata = [
    {
      value: "Dashboard",
      to: "/dashboard",
      icon: <BiHomeSmile color='purple' />
    },
    {
      value: "Payment",
      to: "/veiwpayment",
      icon: <MdPayment color='purple' />,
    },
    {
      value: "Registered Std",
      to: "/registeredstd",
      icon: <FcBusinessman color='purple' />
    }
  ];


  const logOut = () => {
    signOut(auth).then(() => {
      Swal.fire({
        icon: 'success',
        title: "Log Out Successfully",
      }).then(() => {

        window.location.replace("../SignIn")
      })
    }).catch((error) => {
      Swal.fire({
        icon: 'success',
        title: error.message,
      })
    });

  }

  return (
    <>
      <Navbar className="mx-auto w-full fixed top-0  z-40 right-0 left-0  ">
        <div className="relative mx-auto flex items-center justify-between text-blue-gray-900">
          <Typography
            as="a"
            href="#"
            className="mr-4 ml-2 cursor-pointer py-1.5 font-medium"
          >
          STD MANAGMENT SYSTEM
          </Typography>

          <IconButton
            size="sm"
            color="blue-gray"
            variant="text"
            onClick={toggleIsNavOpen}
            className="ml-auto mr-2 lg:hidden"
          >
            <Bars2Icon className="h-6 w-6" />
          </IconButton>

          {/* profile */}
          <Menu open={isMenuOpen} handler={setIsMenuOpen} placement="bottom-end">
      <MenuHandler>
        <Button
          variant="text"
          color="blue-gray"
          className="flex items-center gap-1 rounded-full py-0.5 pr-2 pl-0.5 lg:ml-auto"
        >
          <Avatar
            variant="circular"
            size="sm"
            alt="tania andrew"
            className="border border-gray-900 p-0.5"
            src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1480&q=80"
          />
          <ChevronDownIcon
            strokeWidth={2.5}
            className={`h-3 w-3 transition-transform ${isMenuOpen ? "rotate-180" : ""
              }`}
          />
        </Button>
      </MenuHandler>
      <MenuList className="p-1">
        {profileMenuItems.map(({ label, icon }, key) => {
          const isLastItem = key === profileMenuItems.length - 1;
          return (
            <MenuItem
              key={label}
              onClick={closeMenu}
              className={`flex items-center gap-2 rounded ${isLastItem
                  ? "hover:bg-red-500/10 focus:bg-red-500/10 active:bg-red-500/10"
                  : ""
                }`}
            >
              {createElement(icon, {
                className: `h-4 w-4 ${isLastItem ? "text-red-500" : ""}`,
                strokeWidth: 2,
              })}
              <Typography
                as="span"
                variant="small"
                className="font-normal"
                color={isLastItem ? "red" : "inherit"}
                onClick={logOut}
              >
                {label}
              </Typography>
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>       
        </div>

      </Navbar>

      <aside id="logo-sidebar" class="fixed top-0 left-0  w-64 border-2 h-full pt-20 transition-transform -translate-x-full  sm:translate-x-0" aria-label="Sidebar">

        <Card className="h-full w-full max-w-[20rem] p-4 mt-[-20px] shadow-xl shadow-blue-gray-900/5">
          <div className="mb-2 p-4">
            <Typography variant="h5" color="blue-gray">
              Rizwan STD
            </Typography>
          </div>
          <List>
            {
              navdata.map((item, i) => {
                return (

                    <NavLink to={item.to} className={window.location.pathname==item.to?`bg-gray-300 rounded-md`:''}  >
                  <ListItem key={i}>
                    <ListItemPrefix>
                      {item.icon}
                    </ListItemPrefix>
                      {item.value}
                  </ListItem>
                    </NavLink>
                )

              })
            }

            {/* 
        <ListItem>
          <ListItemPrefix>
            <PowerIcon className="h-5 w-5" />
          </ListItemPrefix>
          Log Out
        </ListItem> */}
          </List>
        </Card>


        {/* <div style={{width:"100%"} }>

          <Tabs value='dashboard'   orientation="vertical">
      <TabsHeader   style={{width:"252px"}} >
        {data.map(({ label, value }) => (
             <NavLink to={`/${value}`}>
             <Tab  id='listget' key={value}
                 className='  flex justify-start p-3'
                  value={value} >
                   {label}

          </Tab>
                   </NavLink>
        ))}
      </TabsHeader>

    </Tabs>
        </div> */}
      </aside>

    </>
  )
}


export default memo(Nav);